
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Table } from "../../Widgets/Table/Table.js";
import { empty, ofArray, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function ReportView(props) {
    let elems_2, elems_1, elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", "flex-grow-1 d-flex flex-column"], (elems_2 = [reactElement("div", createObj(ofArray([["id", "releasedate"], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Report.Rows), {
        ColumnDefinitions: [new ColumnDefinition$1("releaseDate", "", t("general.release_date"), (row) => (new CellContent(6, [row.ReleaseDate])), "text", "date"), new ColumnDefinition$1("currentReceiverName", "", t("general.current_receiver"), (dto) => {
            const matchValue = dto.ReceiverInformation.CurrentReceiverOnClickPath;
            if (matchValue == null) {
                return new CellContent(0, [""]);
            }
            else {
                const onClickPath = matchValue;
                return new CellContent(2, [dto.ReceiverInformation.CurrentReceiverName, () => {
                    RouterModule_nav(ofArray(toArray(onClickPath)), 1, 1);
                }]);
            }
        }, "select", "button"), new ColumnDefinition$1("displayName", "", t("general.tool"), (dto_1) => (new CellContent(2, [dto_1.DisplayName, () => {
            RouterModule_nav(ofArray(toArray(dto_1.ToolInformation.OnClickPath)), 1, 1);
        }])), "text", "button"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_2) => (new CellContent(0, [row_2.Model])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_3) => (new CellContent(0, [row_3.SerialNumber])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_4) => (new CellContent(0, [row_4.InventoryNumber])), "text", "text"), new ColumnDefinition$1("storageName", "", t("general.storage"), (row_5) => (new CellContent(0, [row_5.StorageInformation.StorageName])), "select", "text"), new ColumnDefinition$1("storageSpace", "", t("tool.storage_space"), (row_6) => (new CellContent(0, [row_6.StorageInformation.StorageSpace])), "text", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["releaseDate", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

